import * as React from 'react'
import { Text, TextStyle } from 'react-native'
import { styles } from './styles'

type BodyProps = {
  children?: React.ReactNode
  style?: TextStyle
}

export function Body({ children = '', style = undefined }: BodyProps) {
  return <Text style={[styles.body, style]}>{children}</Text>
}
